import {useEffect, useState, ReactNode} from 'react';

import {useLocation} from 'react-router-dom';

import AdobeTargetBaseProvider from 'components/app/AdobeTargetProvider/AdobeTargetBaseProvider';
import {useAdobeTargetState} from 'utils/adobe-target';
import Loadable from 'utils/Loadable';

export const adobeLoadedEvent = 'at-library-loaded';

interface Props {
  children: ReactNode;
  partyUUID?: string;
}

const AsynchAdobeTargetAuthenticatedProvider = Loadable({
  loader: () => import('components/app/AdobeTargetProvider/AdobeTargetAuthenticatedProvider')
});

const AdobeTargetProvider = ({children, partyUUID}: Props) => {
  const [parameters, setParameters] = useAdobeTargetState();

  const adobe = (window as any).adobe as any;
  const [isAdobeLoaded, setIsAdobeLoaded] = useState(!!adobe?.target);

  const {pathname} = useLocation();

  useEffect(() => {
    const adobeIsLoaded = () => setIsAdobeLoaded(true);
    document.addEventListener(adobeLoadedEvent, adobeIsLoaded);
    return () => {
      document.removeEventListener(adobeLoadedEvent, adobeIsLoaded);
    };
  }, []);

  if (partyUUID) {
    return (
      <AsynchAdobeTargetAuthenticatedProvider
        {...{adobe, pathname, isAdobeLoaded, children, parameters, setParameters}}
      />
    );
  }

  return <AdobeTargetBaseProvider {...{adobe, pathname, isAdobeLoaded, children, parameters, setParameters}} />;
};

export default AdobeTargetProvider;
